import React, { useEffect, useRef } from 'react'
import { IStyledSelect } from '../../interfaces/FormFields'
import useStyledSelect from '../../hooks/useStyledSelect'

const StyledSelect = ({
  id,
  options,
  placeHolder,
  error,
  reaccesSelectedOption,
  updateReacessSelectedOption,
  resetSelectWithId,
}: IStyledSelect) => {
  const { state, dispatch } = useStyledSelect(placeHolder || options[0].label)

  const { selectedOption, showOptionsDropdown } = state
  const node = useRef<HTMLDivElement>(null)

  const clickedOutsideComponent = (event: any) => {
    if (node && node.current && node.current.contains(event.target)) return
    dispatch({ type: 'clickOutsideCloseDropdown' })
  }

  useEffect(() => {
    document.addEventListener('click', clickedOutsideComponent)
    return () => {
      document.removeEventListener('click', clickedOutsideComponent)
    }
    // eslint-disable-next-line
  }, [])

  const triggerStyledSelectChange = (
    select: HTMLSelectElement,
    optionValue: string,
    optionLabel: string
  ) => {
    // eslint-disable-next-line no-param-reassign
    select.value = optionValue
    dispatch({
      type: 'isOptionSelected',
      payload: {
        selectedOption: optionLabel,
        showOptionsDropdown: false,
      },
    })

    const event = document.createEvent('Event')
    event.initEvent('change', true, true)
    select.dispatchEvent(event)
  }

  const handleClick = (optionValue: string, optionId: string) => {
    const element = document.getElementById(optionId) as HTMLSelectElement
    const select = element.parentElement as HTMLSelectElement
    const styleSelectPlaceholder = placeHolder || options[0].label

    triggerStyledSelectChange(select, optionValue, element.innerText)
    updateReacessSelectedOption({
      label: element.innerText,
      index: select.options.selectedIndex,
      isPlaceholder:
        optionValue === '' && element.innerText === styleSelectPlaceholder,
    })

    // Some dropdowns depends on other dropdowns and we need to trigger the
    // change in order to have a correct view of the styledSelect
    if (resetSelectWithId) {
      const selectToReset = document.getElementById(
        resetSelectWithId
      ) as HTMLSelectElement
      if (selectToReset) {
        triggerStyledSelectChange(
          selectToReset,
          '',
          selectToReset.options[0].innerText
        )
      }
    }
  }
  return (
    <div className="inputSelectWrapper" ref={node}>
      <div
        className={`inputSelect inputField ${error ? 'errorHighlight' : ''}`}
        onClick={() =>
          dispatch({
            type: 'clickOutsideCloseDropdown',
            payload: { toggleOptionDropdown: true },
          })
        }
      >
        <div
          className={`inputSelectedOption ${
            reaccesSelectedOption.isPlaceholder
              ? 'inputSelectedOptionPlaceholder'
              : ''
          }`}
        >
          {reaccesSelectedOption.label
            ? reaccesSelectedOption.label
            : selectedOption}
        </div>
      </div>
      {showOptionsDropdown && (
        <ul className="inputSelectOptions listUnstyled">
          {options.map((option, index) => (
            <li key={option.value + id}>
              <button
                onClick={() => {
                  handleClick(option.value, `${option.value + id}option`)
                }}
                className={`inputSelectOptionLabel ${
                  reaccesSelectedOption.index === index
                    ? 'inputSelectOptionSelected'
                    : ''
                } `}
              >
                {option.label}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}

export default StyledSelect
